import { render, staticRenderFns } from "./CloseCrossCtrl.vue?vue&type=template&id=2f3a1e72&"
import script from "./CloseCrossCtrl.vue?vue&type=script&lang=ts&"
export * from "./CloseCrossCtrl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports